import * as React from "react";
import { joinClasses } from "../../../utils/Filters";
import { Button } from "../05-atoms/Button";
import { Icon, IconNames } from "../05-atoms/Icon";
// filterFn
var changeSort = function (column, asc, onSortChange) {
    if (onSortChange) {
        onSortChange(column, asc);
    }
};
var getThClass = function (column, index, columnLength, activeSort, hasActions) { return (joinClasses("scl-m-table__th", column.sortable ? "scl-m-table__th--with-filter" : undefined, column.alignRight ? "align-right" : undefined, activeSort && activeSort.column === index ? "active" : undefined, !!hasActions && index + 1 === columnLength ? "with-actions" : undefined)); };
export var TableHeader = function (props) { return (React.createElement("thead", { className: "scl-m-table__head" },
    React.createElement("tr", { className: "scl-m-table__tr" }, props.columns.map(function (column, index) { return (React.createElement("th", { className: getThClass(column, index, props.columns.length, props.activeSort, props.hasActions), key: "th-".concat(index), onClick: function () { return column.sortable ? changeSort(index, (props.activeSort && props.activeSort.column === index
            ? (props.activeSort
                ? !props.activeSort.asc : true) : (props.activeSort
            ? props.activeSort.asc : true)), props.onSortChange) : null; } }, column.sortable
        ? (React.createElement(Button, { className: "scl-m-table__th-filter-btn" },
            column.label,
            "  ",
            props.activeSort && (React.createElement(Icon, { name: props.activeSort && props.activeSort.asc
                    ? IconNames.SORT_DOWN : IconNames.SORT_UP }))))
        : column.label)); })))); };
